import { EVENT_PAGES } from '../actionTypes';

const initialState = {
  content: [],
  eventReceipt: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EVENT_PAGES.SUCCESS:
      return {
        ...state,
        ...action.payload,
      };
    case EVENT_PAGES.RECEIPT_SUCCESS:
      return {
        ...state,
        eventReceipt: action.payload,
      };
    default:
      return state;
  }
};
